/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';

import type { LuggageTypes } from '@lt/api/dist/methods/packages/types';
import type { LuggageParams, LuggageType } from 'src/components/Luggage/types';
import styled from 'styled-components';
import FlightsLuggageIcon from './components/FlightsLuggageIconWithLabel';

import { luggageToArray } from '../../../../../../../../components/Luggage/luggageUtils';
import FlightsLuggageTooltipMobile from './components/FlightsLuggageTooltipMobile';

const baseCls = 'checkout-flight-luggage';

type FlightsLuggageProps = {
  luggage: LuggageTypes;
  className?: string;
  isMobile?: boolean;
  isSelected?: boolean;
  isLabelInside?: boolean;
};

const FlightsLuggage = ({
  luggage,
  className = '',
  isMobile = false,
  isLabelInside = false,
}: FlightsLuggageProps) => {
  const luggageArray = luggageToArray(luggage) as [
    LuggageType,
    LuggageParams,
  ][];

  const [isTooltipOpened, setIsTooltipOpened] = useState(false);

  const luggageTooltipProps = isMobile
    ? {}
    : {
        'data-luggage': JSON.stringify(luggageArray),
      };

  return (
    <div className={`${baseCls} ${className}`}>
      <LuggageIconsContainer
        {...luggageTooltipProps}
        onClick={() => setIsTooltipOpened(true)}
      >
        {luggageArray.map(([type, luggageParams]) => (
          <FlightsLuggageIcon
            isLabelInside={isLabelInside}
            key={type}
            weight={luggageParams.weight}
            count={luggageParams.count}
            type={type}
          />
        ))}
      </LuggageIconsContainer>
      {isTooltipOpened && isMobile && (
        <FlightsLuggageTooltipMobile
          luggageArray={luggageArray}
          setIsTooltipOpened={setIsTooltipOpened}
          isTooltipOpened={isTooltipOpened}
        />
      )}
    </div>
  );
};

const LuggageIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export default FlightsLuggage;
